<template>
  <section class="news-info-container">
    <b-container class="h-100">
      <b-row class="h-100 align-content-center space-row">
        <b-col class="col-xs-6" offset-lg="2" sm="6" md="6" lg="auto">
          <div class="news-content-list-img">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/news/news-list-eng-1.png" alt="News image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/news/news-list-ukr-1.png" alt="News image">
            <img v-else class="main-photo" src="../../assets/img/news/news-list-eng-1.png" alt="News image">
          </div>
        </b-col>
        <b-col class="col-xs-6" sm="6" md="6" lg="5">
          <Scrollama class="news-content-list-text" @step-enter="stepEnterHandler" :offset="0.8">
            <div class="content-box appear" data-step="1">
              <h1 class="title" v-html="$t('daily_news_from_grexy')"></h1>
              <p class="subtitle" v-html="$t('daily_news_from_grexy_text')"></p>
            </div>
            <div class="content-box appear" data-step="2">
              <h1 class="title" v-html="$t('posts_from_community_members')"></h1>
              <p class="subtitle" v-html="$t('posts_from_community_members_text')"></p>
            </div>
            <div class="content-box appear" data-step="3">
              <h1 class="title" v-html="$t('emergency_messages')"></h1>
              <p class="subtitle" v-html="$t('emergency_messages_text')"></p>
            </div>
          </Scrollama>
        </b-col>
      </b-row>
      <b-row class="h-100 align-content-center">
        <b-col class="col-xs-6" offset-lg="2" sm="6" md="6" lg="auto">
          <div class="news-content-list-img">
            <img v-if="$i18n.locale === 'en'" class="main-photo" src="../../assets/img/news/news-list-eng-2.png" alt="News image">
            <img v-else-if="$i18n.locale === 'uk'" class="main-photo" src="../../assets/img/news/news-list-ukr-2.png" alt="News image">
            <img v-else class="main-photo" src="../../assets/img/news/news-list-eng-1.png" alt="News image">
          </div>
        </b-col>
        <b-col class="col-xs-6" sm="6" md="6" lg="5">
          <Scrollama class="news-content-list-text" @step-enter="stepEnterHandler" :offset="0.8">
            <div class="content-box appear" data-step="4">
              <h1 class="title" v-html="$t('participate_in_discussions')"></h1>
              <p class="subtitle" v-html="$t('participate_in_discussions_text')"></p>
            </div>
          </Scrollama>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import Scrollama from 'vue-scrollama'

export default {
  components: {
    Scrollama
  },

  data () {
    return {}
  },
  methods: {
    stepEnterHandler ({ element }) {
      element.classList.add('appearing')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/app";
.appear {
  opacity: 0;
  transform: translateY(50px); /* Зміна положення по вертикалі */
  transition: opacity 0.5s ease, transform 0.5s ease; /* Анімація з'явлення */
}

.appear.appearing {
  opacity: 1;
  transform: translateY(0); /* Повернення до початкового положення */
}
section.news-info-container {
  padding-top: 47px;
  padding-bottom: 10px;

  .space-row{
    margin-bottom: 66px;
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
    }
  }

  .news-content-list-img {
    display: flex;
    justify-content: center;
    align-items: center;
    .main-photo{
      width: 100%;
      max-width: 272px;
      height: auto;
    }
  }

  .news-content-list-text {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 106px;
    @media screen and (min-width: 320px) {
      padding-top: 20px;
      gap: 8px;
    }
    @media screen and (min-width: 576px) {
      padding-top: 106px;
      gap: unset;
    }
    .content-box {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 16px;
      font-family: $main-font;
      color: #30394B;
      .title{
        font-size: 24px;
        font-weight: 700;
        line-height: 28.8px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 120%;
        }
        @media screen and (min-width: 425px) {
          font-size: 4vw;
          line-height: 120%;
        }
        @media screen and (min-width: 576px) {
          font-size: 24px;
          font-weight: 700;
          line-height: 28.8px;
        }
      }
      .subtitle{
        font-size: 18px;
        font-weight: 300;
        line-height: 25.2px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 12px;
          line-height: 140%;
        }
        @media screen and (min-width: 425px) {
          font-size: 3vw;
          line-height: 140%;
        }
        @media screen and (min-width: 576px) {
          font-size: 18px;
          font-weight: 300;
          line-height: 25.2px;
        }
      }
    }
  }
}
</style>
